export enum HotspotDetailPosition {
  LEFTTOP = 'left-top',
  RIGHTTOP = 'right-top',
  LEFTBOTTOM = 'left-bottom',
  RIGHTBOTTOM = 'right-bottom',
  CENTERTOP = 'center-top',
  CENTERBOTTOM = 'center-bottom'
}

export interface HotspotPostition {
  top?: string;
  left?: string;
  bottom?: string;
  right?: string;
}

export interface Hotspot {
  id: string;
  openImmediately?: boolean;
  detailPosition?: HotspotDetailPosition;
  customClass?: string;
  text?: string;
  buttons?: Array<HotspotButton>;
  // Positions might also contain auto so defining string as a type
  position?: HotspotPostition;
}

export enum HotspotButtonType {
  NAVIGATE = 'navigate',
  EMIT = 'emit'
}

export interface HotspotButton {
  label: string;
  link: string;
  type?: HotspotButtonType;
  customClass?: string;
}

export interface HotspotInteraction {
  hotspotID: string;
  open: boolean;
}
